import { useVariable } from '@softwareimaging/backstage';
import { Variables } from '../../backstage/config';
import { useGraph } from '../GraphProvider';
import { useQuery } from '../QueryProvider';

import {
  Manifest,
  getFileFromOneDrive,
  ResolvedSidecarFile,
  readManifest,
  createFileFromOneDrive
} from '@sidecarcms/core';

export const useSidecarTemplates = () => {
  const rawManifest = useVariable<Variables>('sidecarManifest');
  if (!rawManifest) throw new Error('Sidecar manifest not found');
  return readManifest(rawManifest) as unknown as Manifest;
};

export function useSidecarFile<T = unknown>(itemId: string) {
  const { client } = useGraph();
  const driveId = useVariable<Variables>('driveId');
  if (!driveId) throw new Error('Drive ID not found');
  return useQuery<ResolvedSidecarFile<T> | undefined>(['sidecar', itemId, driveId], async () => {
    try {
      const [resolvedSidecarFile] = await getFileFromOneDrive<T>(`/drives/${driveId}/items/${itemId}`, client);
      return resolvedSidecarFile;
    } catch (error) {
    }

  });
}

interface SidecarFileArgs<T> {
  templateName: string;
  title: string;
  description: string;
  data: T;
}

export const useCreateSidecarFileFromTemplate = () => {
  const manifest = useSidecarTemplates();
  const { client } = useGraph();

  return async <T = unknown>(args: SidecarFileArgs<T>) => {
    const { templateName, title, description, data } = args;
    const config = manifest[templateName];
    if (!config) throw new Error(`Config for template ${templateName} not found`);
    return createFileFromOneDrive<T>(manifest, templateName, title, description, data, client);
  };
};
